import buyerEn from './buyer-en';

const common = {
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  RESET: 'Reset',
  SUBMIT: 'Submit',
  SAVE: 'Save',
  REMOVE: 'Delete',
  SAVING: 'Saving',
  FIELD_REQUIRED: 'This field is required',
  SEARCH: 'Search',
  LOADING: 'Loading',
  NO_DATA: 'No data',
  GO_BACK: 'Go back',
  COMMON_NONE: 'None',
  COMMON_REFRESH: 'Refresh',
  COMMON_PULL_TO_REFRESH: 'Pull to refresh',
  COMMON_RELEASE_TO_REFRESH: 'Release to refresh',
  COMMON_REFRESHING: 'Refreshing…',
  SIGN_IN: 'Sign in',
  PASSWORD: 'Password',
  PLEASE_ENTER_YOUR_PASSWORD: 'Please enter your password',
  PAGE_NOT_FOUND: 'Page not found',
  THE_REQUESTED_PAGE_COULD_NOT_BE_LOCATED: 'The requested page could not be located.',
};

export default {
  translation: {
    ...common,
    ...buyerEn,
  },
};
